import { useParams } from 'react-router-dom';
import { GenerateTestDataButton } from './GenerateTestDataButton';
import { generateTestOrders } from '../utils/ordersGenerator';

export const GenerateOrdersButton = () => {
  const { id: customerId } = useParams();
  const generateFunction = (count: number) => generateTestOrders(count, customerId);

  return (
    <GenerateTestDataButton 
      label="Generate Orders" 
      generateFunction={generateFunction} 
      queryKey={['orders']} 
    />
  );
};